import { render, staticRenderFns } from "./CPOpenAccountSourceOfFundsTable.vue?vue&type=template&id=2aba08a8&scoped=true&"
import script from "./CPOpenAccountSourceOfFundsTable.vue?vue&type=script&lang=ts&"
export * from "./CPOpenAccountSourceOfFundsTable.vue?vue&type=script&lang=ts&"
import style0 from "./CPOpenAccountSourceOfFundsTable.vue?vue&type=style&index=0&id=2aba08a8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aba08a8",
  null
  
)

export default component.exports